import { type RefObject, useContext, useMemo } from 'react';
import { PreferenceOptionsPage } from '../../components/PreferenceOptionPage/PreferenceOptionPage';
import { ToggleVariant } from '../../components/Toggle/Toggle/Toggle';
import { EatingHabit } from '../../defs/quiz';
import { QuizContext } from '../../quiz-context';

interface Props {
  testid: string;
  scrollRef: RefObject<HTMLDivElement>;
}

export function FoodQualities(props: Props) {
  const { quiz } = useContext(QuizContext);

  const grassFedMeatTagId = 815;
  const wildCaughtSeafoodTagId = 806;

  const tagExclusions = useMemo(() => {
    if (
      quiz.habits === EatingHabit.Vegetarian ||
      quiz.habits === EatingHabit.Vegan
    ) {
      return [grassFedMeatTagId, wildCaughtSeafoodTagId];
    }

    if (quiz.habits === EatingHabit.Pescatarian) {
      return [grassFedMeatTagId];
    }
  }, [quiz.habits]);

  return (
    <PreferenceOptionsPage
      testid={props.testid}
      heroText="What qualities do you shop for?"
      subCopy="We’ll prioritize foods that meet your selections."
      ariaLabel="Select what qualities you shop for"
      preferenceOptionKey="preference_options.food_quality"
      question="foodQualities"
      layoutVariant="two-column"
      toggleType={ToggleVariant.Three}
      tagExclusions={tagExclusions}
      scrollRef={props.scrollRef}
      trackingEventName="Quiz Food Qualities"
    />
  );
}
